import React from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'

export function useRouterCompat() {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()

  const history = React.useMemo(
    () => ({
      push: (path, state) => navigate(path, { state }),
      replace: (path, state) => navigate(path, { replace: true, state }),
      go: (n) => navigate(n),
      goBack: () => navigate(-1),
      goForward: () => navigate(1)
    }),
    [navigate]
  )

  const match = React.useMemo(
    () => ({
      params,
      url: location.pathname,
      path: location.pathname
    }),
    [params, location.pathname]
  )

  return { history, location, match }
}

export function CompatRoute({ component: Component, ...rest }) {
  const { history, location, match } = useRouterCompat()
  return <Component {...rest} history={history} location={location} match={match} />
}

export function withRouter(Component) {
  function WithRouter(props) {
    const { history, location, match } = useRouterCompat()
    return <Component {...props} history={history} location={location} match={match} />
  }
  WithRouter.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`
  return WithRouter
}
